import { formatCurrency, r2 } from '@/lib/utils'
import { IconAlertTriangle } from '@/components/icons/Icons'

interface Props {
  presupuesto: number
  gastado: number
  moneda: string
}

export default function ProjectBudgetAlert({ presupuesto, gastado, moneda }: Props) {
  if (presupuesto <= 0) return null

  const pct = Math.round((gastado / presupuesto) * 100)

  if (pct < 80) return null

  const isExceeded = pct >= 100
  const remaining = r2(presupuesto - gastado)
  const excess = r2(gastado - presupuesto)

  return (
    <div className={`project-budget-alert ${isExceeded ? 'project-budget-alert--danger' : 'project-budget-alert--warning'}`}>
      <IconAlertTriangle size={18} />
      <span>
        {isExceeded ? (
          <>
            <strong>Presupuesto excedido</strong> por {formatCurrency(excess, moneda)}
          </>
        ) : (
          <>
            <strong>Presupuesto al {pct}%</strong> — queda {formatCurrency(remaining, moneda)}
          </>
        )}
      </span>
    </div>
  )
}
